import { connect } from 'react-redux';
import uuid from 'node-uuid';
import withContent from '../../../containers/withContent';
import { withScrollTop } from '../../../containers/withScrollTop';
import chapsPaymentContent from '../ChapsPayments/chapsPayment.content';
import LandingPage from '../../../sharedComponents/LandingPage/LandingPage';

import { getAccountsWithChapsCapability } from '../../../states/accounts/selectors';
import { getPayees } from '../../../states/payees/selectors';
import { getTemplateListByType } from '../../../states/templates/selectors';
import { hasPaymentTypeCapability } from '../../../states/capabilities/selectors';

import { TYPE_CHAPS } from '../../../config';
import { fetchTemplates, selectPaymentTemplate, editPaymentTemplate } from '../../../states/templates/actions';
import { toggleTemplateMode } from '../../../states/templates/toggleTemplateMode';
import { pages, goToPage, resetApp } from '../../../states/page/actions';
import { createNewChapsTemplate } from '../../../states/chaps/actions';
import { setSelectedFromAccount } from '../../../states/payeeSelector/actions';
import { getSelectedFromAccount } from '../../../states/payeeSelector/selectors';
import { getSubmissionDates } from '../../../states/calendar/selectors';
import { toggleBatch } from '../../../states/batch/actions';
import { isPaymentInEditMode } from '../../../states/modes/selectors';

const mapState = (state) => ({
	toAccounts: [],
	fromAccounts: getAccountsWithChapsCapability(state),
	toPayees: getPayees(state),
	templates: getTemplateListByType(state, TYPE_CHAPS),
	showPaymentTabs: hasPaymentTypeCapability(state, TYPE_CHAPS),
	fromAccount: getSelectedFromAccount(state),
	submissionDates: getSubmissionDates(state),
	isEditMode: isPaymentInEditMode(state),
});

const mapDispatch = (dispatch) => ({
	handleCreateNewTemplate: () => {
		dispatch(createNewChapsTemplate({ id: uuid.v1() }));
		dispatch(toggleTemplateMode(true));
		dispatch(goToPage(pages.ChapsPayments));
	},
	fetchTemplates: () => dispatch(fetchTemplates()),
	handleSelectTemplate: (id) => dispatch(selectPaymentTemplate(id)),
	handleEditTemplate: (id, name) => dispatch(editPaymentTemplate(id, name)),
	goToPayeeSelector: () => dispatch(goToPage(pages.ChapsPayeeSelector)),
	setSelectedFromAccount: (fromAccount) => dispatch(setSelectedFromAccount(fromAccount)),
	handleToggleIsBatch: (isBatch) => dispatch(toggleBatch(isBatch)),
	reset: () => dispatch(resetApp),
});

export const connectWrapper = connect(mapState, mapDispatch)(LandingPage);
const contentWrapper = withContent({ content: chapsPaymentContent });
export default withScrollTop(contentWrapper(connectWrapper));
